<template>
	<div class="ReSquareCost">
		<div v-for="(objCost, obj_index) in value" :key="obj_index">
			<!-- <label class="mt-3 "><span>Стоимость за площадь части</span></label> -->

			<div class="row " >
				<div class="fieldset col-md-10" >
					<base-input
						type="number"
						placeholder="Площадь"
						v-model="objCost.square"
						@blur="handlerBlur(value)"
					>
					</base-input>
					<base-input	
						type="number"
						placeholder="Цена"
						v-model="objCost.price"
						@blur="handlerBlur(value)"
					>
					</base-input>
				</div>
				<div class="btnGroup col-md-2">
					<button class="btn btn-icon btn-simple btn-danger" @click="delObjCost(obj_index)">
						<i class="tim-icons icon-trash-simple"></i>
					</button>
				</div>
			</div>
			
		</div>
		<button class="btn btn-simple btn-primary" @click="addEmptyobjCost()">
			Дублировать стоимость
		</button>
	</div>
</template>

<script>
/*
я тут до конца осознал про v-model и props value внутри компонента:
радовался тому что в value можно писать и всё работает - нихрена. 
1) Если value сложный тип (например массив или объект) - тогда можно элементы массива/объекта и ничего за это не будет, т.к. ЖС говно
2) Если тип простой string или number - то хер чё поменяешь в value, только this.$emit('input', 'ЗНАЧЕНИЕ');
3) Если напрямую переписывать сложные тип, например value = {key:'value'} - то хер, будет ошибка
а ещё во всех слуаях он выдаст ошибку, но значение в value запишет
*/
/* Сломалась реактивность на объекте или массиве: 
	Этот чудесный кослыль родился потому что VUE не может нормально следить за массивами и теряется реактивность
	https://v2.vuejs.org/v2/guide/reactivity.html#Change-Detection-Caveats

Для объекта:
	this.$set(this.objChosenTP,this.ApiData[i].siteId, {'choise':'','cost':0, 'phone':{"contact_id":"","contact_type":"1","contact_value":"","contact_view":"","contact_group":"phone"}});
Для Массива:
	Vue.set(this.masCheckListParams,obj_index, [{val_id:obj_index, elements: masElements}]);
*/
	export default {
		name: 'ReSquareCost',
		components: {

		},
		props: {
			// counter: String,
			findId: { //это свойсво удалять не надо, оно хорошее и моет быть использовано в опуиях для формпринтера или фильтрпринтера
				type: String,
				default: '',
			},
			// value: [String,Array],
			value: {
				type: Array,
				default(){return [{
					square: '',
					price: '',
					
				}];}
			},
			label: String,
			// bShowView:{
			// 	type: Boolean,
			// 	default: true
			// },
		},
		data () {
			return {
				ver: 1,
				bufferValue: '',
			}
		},
		watch:{
			// value(val){
			// 	this.bufferValue = this.$GVO.unlinkObject(val);
			// },
			// bufferValue(val){
			// 	this.bufferValue = val;
			// 	this.$emit("input", this.bufferValue);
			// },
			
		},
		computed: {

		},
		methods: {
			addEmptyobjCost(){
				this.value.push({
					square: '',
					price: '',
				});
				
			},
			delObjCost(ind){
				// if(this.value[ind].contact_id != ''){
				// 	if(!this.$GVO.isEmpty(this.delMethod)){
				// 		let apiParam = this.delMethod.apiParam;
						
				// 		if(apiParam.obj == 'client'){
							
				// 			apiParam.flt.id=this.$route.params.client_id;
				// 			apiParam.flt.contact_id=this.value[ind].contact_id;
				// 		}
				// 		this.$GVO.ApiCall(this.delMethod.apiMethod,apiParam)
				// 			.then((objApi) => {  /*console.log(objApi); console.log('УСПЕШНОЕ УДАЛЕНИЕ КОНТАКТА');*/ })
				// 			.catch((errorObjApi) => {console.log(errorObjApi)});
				// 	}
				// }
				this.value.splice(ind,1);
			},
			handlerBlur(element){
				// меняем в числах запятую на точку.
				// element.element_model = String(element.element_model).replace(',','.');
				for (let i = 0; i < element.length; i++){
					if(element[i].price) element[i].price = Math.floor(element[i].price);
					// if(element[i].square) element[i].square = Math.floor(element[i].square);
					if(element[i].square && element[i].square !=undefined  && element[i].square < 0 ){ 
						element[i].square = element[i].square * -1; //дедлаем значение положительным
					}
					if(element[i].price && element[i].price !=undefined  && element[i].price < 0 ){ 
						element[i].price = element[i].price * -1; //дедлаем значение положительным
					}
				}
				// console.log('val', element);
			},

		},
	}
</script>
<style scoped>
	.ReSquareCost .fieldset{
		display: flex;
		justify-content: flex-start;
		align-items: center;
	}
	.ReSquareCost .fieldset > *{
		width: 100%; 
		margin-bottom: 0px;
	}
	/* .ReSquareCost .fieldset:not(.no-select) > div:nth-child(1){width: 250px;} */
	.ReSquareCost .btnGroup{
		display: flex;
		align-items: center;
	}
	.cc-item{
		margin-bottom: 15px;
	}
	.ReSquareCost >>> .el-input__inner {font-size: 0.75rem;}
	.ReSquareCost >>> .fieldset > div:nth-child(2) .form-control {height: 38px;}
	.ReSquareCost >>> .fieldset > div:nth-child(1) input {
		border-top-right-radius: 0;
		border-bottom-right-radius: 0;
	}
	.ReSquareCost >>> .fieldset > div:nth-child(2) input {
		border-top-left-radius: 0;
		border-bottom-left-radius: 0;
	}

</style>
